// 9fbef606107a605d69c0edbcd8029e5d 
export default {
  PRODUCT_ADD_TO_BAG_AVAILABLE: 'available',
  PRODUCT_ADD_TO_BAG_UNAVAILABLE: 'unavailable',
};
